<template>
    <div class="read-history-container" v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container">
            <span>閱讀記錄</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div class="bookListContainer">
            <ul>
                <li v-for="book in bookList">
                    <div @click="getBookDetail(book.bookId)">
                        <img :src="book.pic1" alt="">
                        <span style="color: black;top: 10%;font-weight: bold">{{book.title}}</span>
                        <span style="top: 25%;color: #999999">作者：{{book.author}}</span>
                        <span style="top: 40%;color: #333333" class="book-dis">{{book.content}}</span>
                    </div>
                </li>
            </ul>

            <div @click="loadMore" class="more-style" v-if="showLoadMore">
                <span>更多</span>
            </div>

        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "LookHistoryVue",
    data() {
        return {
            userId: "",
            bookList: [],
            page: 1,
            allPage: 0,
            isRequest: false,
            isLoadMore: false,
            showLoadMore: true,
        };
    },
    methods: {
        //返回
        backClick: function () {
            this.$router.push({
                path: "MineVue",
            });
        },

        //獲取閱讀歷史列表
        getReadHistoryList: function () {
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getTracks");
            params.append("uid", this.userId);
            params.append("type", "0");
            params.append("page", this.page);
            this.isRequest = true;
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.allPage = res.data.pages;
                    this.showLoadMore = this.page < this.allPage;
                    if (this.isLoadMore) {
                        let list = res.data.data;
                        for (let i = 0; i < list.length; i++) {
                            this.bookList.push(list[i]);
                        }
                    } else {
                        this.bookList = res.data.data;
                    }
                } else {
                    this.showLoadMore = false;
                    alert(res.data.msg);
                }
            });
        },

        //加載更多
        loadMore: function () {
            this.isLoadMore = true;
            this.page++;
            this.getReadHistoryList();
        },

        //獲取書籍詳情
        getBookDetail: function (bookId) {
            this.$router.push({
                path: "BookDetailVue",
                query: {
                    bookId: bookId,
                    vueName: "LookHistoryVue",
                },
            });
        },
    },

    created() {
        this.userId = localStorage.getItem("userId");
        this.getReadHistoryList();
    },
};
</script>

<style scoped>
.read-history-container {
    max-width: 480px;
    min-height: 100vh;
    margin: 0 auto;
    border: 1px solid lightgoldenrodyellow;
}

.bookListContainer {
    margin-top: 50px;
    overflow-x: hidden;
}

.bookListContainer ul {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    text-align: left;
}

.bookListContainer ul li {
    list-style: none;
    border-bottom: 1px solid gainsboro;
    position: relative;
    padding: 10px;
}

.bookListContainer ul li img {
    width: 20%;
}

.bookListContainer ul li span {
    width: 70%;
    position: absolute;
    margin-left: 22%;
    font-size: 14px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
}

.book-dis {
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 20px;
    height: 60px;
    white-space: normal;
}

.more-style {
    height: 40px;
}

.more-style span {
    line-height: 40px;
}

.more-style:active {
    background-color: lightgrey;
}
</style>



// WEBPACK FOOTER //
// src/components/LookHistoryVue.vue